(function () {
    'use strict';

    angular
        .module('app.account-quotation', [])

        .component('accountQuotations', {
            bindings: {
                device: '<'
            },
            /* @ngInject */
            templateUrl: ["AccountService", function (AccountService) {
                return AccountService.getLinks().AccountQuotations;
            }],

            controllerAs: 'accountCtrl',
            /* @ngInject */
            controller: ["$scope", "$rootScope", "$element", "$location", "$timeout", "AccountService", "HttpService", function ($scope, $rootScope, $element, $location, $timeout, AccountService, HttpService) {
                var ctrl = this;

                AccountService.initAccount(ctrl);

                ctrl.$onInit = function () {
                    $scope.device = ctrl.device;
                    ctrl.loading = true;
                    HttpService.get({
                        url: '/AccountQuotations/Get',
                        cache: false
                    }).then(function (response) {

                        ctrl.quotations = response.results.quotations;

                        _.each(ctrl.quotations, function (quotation) {
                            quotation.addAllEnabled = true;
                            _.each(quotation.WebFolderLines, function (line) {
                                if (!line.Product.AllowAddToCart) {
                                    quotation.addAllEnabled = false;
                                }
                            });
                            $timeout(function () {
                                quotation.init = true;
                            }, 350);
                        });

                        $timeout(function () {
                            ctrl.quotations[0].isOpen = true;
                        }, 1000);

                        ctrl.loading = false;

                    })
                };

                ctrl.quotationPayment = function (event) {
                    //ng - click="accountCtrl.quotationPayment($event)"
                    //window.history.replaceState({}, '', $(event.target).attr('href'));
                };
            }]
        })
})();
